import type { QueryClient } from '@tanstack/react-query'
import { queueManager } from './QueueManager'

export const syncService = {
  async processQueue(queryClient: QueryClient): Promise<void> {
    const result = await queueManager.processAll()
    if (result.succeeded > 0) {
      queryClient.invalidateQueries({ queryKey: ['bookings'] })
      queryClient.invalidateQueries({ queryKey: ['bookings-for-date'] })
      queryClient.invalidateQueries({ queryKey: ['booking'] })
      queryClient.invalidateQueries({ queryKey: ['tables'] })
      queryClient.invalidateQueries({ queryKey: ['areas'] })
      queryClient.invalidateQueries({ queryKey: ['pos-orders'] })
      queryClient.invalidateQueries({ queryKey: ['pos-order'] })
      queryClient.invalidateQueries({ queryKey: ['pos-orders-sync'] })
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['pos-report-eod'], refetchType: 'all' }),
        queryClient.invalidateQueries({ queryKey: ['pos-report-items'], refetchType: 'all' }),
        queryClient.invalidateQueries({ queryKey: ['pos-report-daily'], refetchType: 'all' }),
      ])
      queryClient.invalidateQueries({ queryKey: ['pos-day-session'] })
      // Pre-order items are Dexie-backed — no React Query invalidation needed,
      // QueueManager handles temp→real replacement in Dexie directly
    }
  },
}
